module.exports = __webpack_public_path__ + "static/6-f761664815969529feec5a49c6b711e5.jpg";